<!-- 关注后回复页的新建消息弹窗 -->
<template>
  <div>
    <a-modal
      :title="`${handle_title}消息`"
      width="1100px"
      :visible="msg_modal_visible"
      :confirm-loading="msg_modal_loading"
      @ok="msgHandleOk"
      @cancel="msgHandleCancel"
    >
      <div
        @click="bigBox"
        style="
          padding: 20px 35px;
          margin: -20px -20px -40px;
          position: relative;
        "
      >
        <div
          v-if="handle_title == '新建'"
          style="
            display: flex;
            align-items: flex-start;
            margin-bottom: 20px;
            position: relative;
          "
        >
          <div class="scroll-big-box" style="width: 100%">
            <div ref="gzh_list_ref" style="">
              <!-- <div style="position: relative;"> -->
              <div
                @click.stop="addMsgGzh"
                class="title-tab-box"
                style="display: inline-block; background-color: #fff"
              >
                <a-icon type="plus" />
              </div>
              <div
                v-for="(item, index) in gzhTabData"
                style="display: inline-block"
                :class="{ 'title-tab-box-selected': item.select_status }"
                class="title-tab-box"
                @click="changeGzhTab(item, index)"
              >
                {{ item.gzh_name }}
              </div>
              <!-- </div> -->
            </div>
          </div>

          <div
            v-show="pl_gzh_select"
            @click.stop
            style="
              background-color: #fff;
              max-height: 320px;
              width: 100%;
              padding: 10px 15px;
              position: absolute;
              z-index: 5;
              box-shadow: 0 3px 5px 3px #eee;
              overflow-y: overlay;
            "
            :style="{ top: gzh_list_top + 'px' }"
          >
            <div
              style="
                margin-bottom: 12px;
                font-weight: 600;
                font-size: 15px;
                user-select: none;
              "
            >
              添加公众号：（当前书城：{{ msg_channel_name }}）
            </div>
            <div
              v-for="(item, index) in gzhData"
              :key="index"
              style="margin-bottom: 25px"
            >
              <a-checkbox
                :indeterminate="item.indeterminate_all"
                :checked="item.checked_all"
                @change="onCheckAllChange($event, item, index)"
              >
                {{ item.label }}
              </a-checkbox>
              <div
                style="
                  display: flex;
                  align-items: center;
                  flex-wrap: wrap;
                  margin-left: 20px;
                  margin-top: 10px;
                "
              >
                <div
                  v-for="(item_z, index_z) in item.value"
                  :key="index_z"
                  style="margin-bottom: 5px; margin-right: 10px"
                >
                  <a-checkbox
                    :checked="item_z.checked_z"
                    @change="onCheckChange($event, index, index_z)"
                  >
                    {{ item_z.gzh_name }}
                  </a-checkbox>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="form-cell-box">
          <div v-if="page_type == 'contact'" class="class-title">消息名称</div>
          <div v-else class="class-title">关键词</div>
          <a-input
            v-model="gzhTabData[gzh_tab_index].contentData.e_title"
            placeholder="请输入"
            :style="{ width: modal_width + 'px' }"
          />
        </div>

        <div v-if="page_type == 'contact'" class="form-cell-box">
          <div class="class-title">推送时机</div>
          <div style="display: inline-block; align-items: center">
            <span>用户互动后</span>
            <a-input-number
              :min="1"
              :max="2879"
              v-model="gzhTabData[gzh_tab_index].contentData.e_send_time"
              style="width: 70px; margin: 0 10px"
            />
            <span>分钟</span>
            <span style="font-size: 13px; color: #b5b3b3; margin-left: 15px"
              >说明：可以填写 1 到 2879 分钟</span
            >
          </div>
        </div>

        <div class="form-cell-box">
          <div class="class-title">回复消息类型</div>
          <div v-if="set_type === 'h5'">
            <a-radio-group
              @change="messTypeA"
              name="radioGroup"
              :value="gzhTabData[gzh_tab_index].contentData.e_type"
            >
              <a-radio :value="1">文本消息</a-radio>
              <a-radio :value="2">图片消息</a-radio>
              <a-radio :value="3">单条图文消息</a-radio>
              <!-- <a-radio :value="5">小程序卡片</a-radio> -->
            </a-radio-group>
          </div>
          <div v-if="set_type === 'mini'">
            <a-radio-group
              @change="messTypeA"
              name="radioGroup"
              :value="gzhTabData[gzh_tab_index].contentData.e_type"
            >
              <a-radio :value="1">文本消息</a-radio>
              <a-radio :value="2">图片消息</a-radio>
              <!-- <a-radio :value="3">单条图文消息</a-radio> -->

              <a-radio :value="5">小程序卡片</a-radio>
            </a-radio-group>
          </div>
        </div>

        <div
          v-if="gzhTabData[gzh_tab_index].contentData.e_type == 1"
          class="form-cell-box"
          style="align-items: flex-start"
        >
          <div class="class-title">文本消息内容</div>
          <div>
            <a-textarea
              v-model="gzhTabData[gzh_tab_index].contentData.e_text_content"
              placeholder="请输入文本消息内容"
              :auto-size="{ minRows: 7, maxRows: 15 }"
              :style="{ width: modal_width + 'px' }"
            />
            <!-- <pre type="text" style="flex: 1 1 0%;padding: 0.25em 0.5em;height: 100%;line-height: 1.5;overflow-wrap: break-word;overflow: hidden scroll;text-align: left;white-space: pre-wrap;">
					亲爱的用户，请按下方提示继续阅读「🔥宋小书」
					🔴回复数字"1"，继续阅读【宋小书】的精彩故事！
					🔴回复数字"1"，继续阅读【宋小书】的精彩故事！
					点击左下角的“⌨️”↙↙↙即可【回复数字】
					</pre> -->
          </div>
        </div>

        <div
          v-if="gzhTabData[gzh_tab_index].contentData.e_type == 2"
          class="form-cell-box"
        >
          <div class="class-title">图片</div>

          <a-upload
            accept="image/*"
            name="image"
            class="avatar-uploader"
            :show-upload-list="false"
            :action="`${$http.excel_url}api/platform/gzh/upload-material`"
            :data="{
              id: config_id,
            }"
            :headers="{
              Authorization: headers_token,
            }"
            :withCredentials="true"
            method="post"
            :before-upload="beforeUpload"
            @change="uploadChange"
          >
            <div
              style="border: 1px dashed #d9d9d9; cursor: pointer; width: 300px"
            >
              <img
                v-if="gzhTabData[gzh_tab_index].contentData.e_img_url"
                :src="gzhTabData[gzh_tab_index].contentData.e_img_url"
                style="width: 100%; height: 150px; object-fit: contain"
                alt=""
              />
              <div
                v-else
                style="
                  height: 150px;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  color: #999;
                "
              >
                <div style="text-align: center">
                  <a-icon
                    :type="e_img_loading ? 'loading' : 'plus'"
                    style="font-size: 22px"
                  />
                  <div>图片上传</div>
                </div>
              </div>
            </div>
          </a-upload>
        </div>

        <div
          v-if="gzhTabData[gzh_tab_index].contentData.e_type == 3"
          class="form-cell-box"
        >
          <div class="class-title">消息标题</div>
          <a-input
            v-model="gzhTabData[gzh_tab_index].contentData.e_txtImg_title"
            placeholder="请输入消息标题"
            :style="{ width: modal_width + 'px' }"
          />
        </div>
        <div
          v-if="gzhTabData[gzh_tab_index].contentData.e_type == 3"
          class="form-cell-box"
        >
          <div class="class-title">消息描述</div>
          <a-input
            v-model="gzhTabData[gzh_tab_index].contentData.e_txtImg_description"
            placeholder="请输入消息描述"
            :style="{ width: modal_width + 'px' }"
          />
        </div>
        <div
          v-if="gzhTabData[gzh_tab_index].contentData.e_type == 3"
          class="form-cell-box"
        >
          <div class="class-title">消息图片</div>
          <div
            style="border: 1px dashed #d9d9d9; cursor: pointer; width: 150px"
          >
            <a-upload
              accept="image/*"
              name="file"
              class="avatar-uploader"
              :show-upload-list="false"
              :action="`${$http.excel_url}api/common/upload-image`"
              :data="{
                type: 5,
              }"
              :headers="{
                Authorization: headers_token,
              }"
              :withCredentials="true"
              method="post"
              :before-upload="txtimgBeforeUpload"
              @change="txtimgUploadChange"
            >
              <div
                class="type-3"
                style="
                  border: 1px dashed #d9d9d9;
                  cursor: pointer;
                  width: 150px;
                  position: relative;
                "
              >
                <img
                  v-if="gzhTabData[gzh_tab_index].contentData.e_txtImg_image"
                  :src="gzhTabData[gzh_tab_index].contentData.e_txtImg_image"
                  style="width: 100%; height: 150px; object-fit: contain"
                  alt=""
                />
                <div
                  v-else
                  style="
                    height: 150px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    color: #999;
                  "
                >
                  <div style="text-align: center">
                    <a-icon
                      :type="e_img_loading ? 'loading' : 'plus'"
                      style="font-size: 22px"
                    />
                    <div>图片上传</div>
                  </div>
                </div>

                <div
                  v-if="gzhTabData[gzh_tab_index].contentData.e_txtImg_image"
                  class="cover-handle"
                >
                  <div
                    @click.stop="cutCover(3)"
                    style="color: #fff; text-align: center; cursor: pointer"
                  >
                    <a-icon style="font-size: 18px" type="scissor" />
                    <div>裁剪封面</div>
                  </div>
                  <div style="color: #fff; text-align: center; cursor: pointer">
                    <a-icon style="font-size: 18px" type="swap" />
                    <div>更换封面</div>
                  </div>
                </div>
              </div>
            </a-upload>
          </div>
        </div>
        <div
          v-if="gzhTabData[gzh_tab_index].contentData.e_type == 3"
          class="form-cell-box"
        >
          <div class="class-title">消息链接URL</div>
          <a-input
            v-model="gzhTabData[gzh_tab_index].contentData.e_txtImg_url"
            placeholder="请输入消息链接URL"
            :style="{ width: modal_width + 'px' }"
          />
        </div>

        <template v-if="gzhTabData[gzh_tab_index].contentData.e_type == 5">
          <div class="form-cell-box">
            <div class="class-title">小程序标题</div>
            <a-input
              v-model="gzhTabData[gzh_tab_index].contentData.xcx_title"
              placeholder="请输入小程序标题"
              :style="{ width: modal_width + 'px' }"
            />
          </div>
          <div class="form-cell-box">
            <div class="class-title">小程序APPID</div>
            <a-input
              v-model="gzhTabData[gzh_tab_index].contentData.xcx_appid"
              placeholder="请输入小程序APPID"
              :style="{ width: modal_width + 'px' }"
            />
          </div>
          <div class="form-cell-box">
            <div class="class-title">小程序路径</div>
            <a-input
              v-model="gzhTabData[gzh_tab_index].contentData.xcx_pagepath"
              placeholder="请输入小程序路径"
              :style="{ width: modal_width + 'px' }"
            />
          </div>
          <div class="form-cell-box">
            <div class="class-title">消息封面</div>
            <div
              style="border: 1px dashed #d9d9d9; cursor: pointer; width: 150px"
            >
              <a-upload
                accept="image/*"
                name="image"
                class="avatar-uploader"
                :show-upload-list="false"
                :action="`${$http.excel_url}api/platform/gzh/upload-material`"
                :data="{
                  id: config_id,
                }"
                :headers="{
                  Authorization: headers_token,
                }"
                :withCredentials="true"
                method="post"
                :before-upload="beforeUpload"
                @change="uploadChange"
              >
                <div
                  class="type-3"
                  style="
                    border: 1px dashed #d9d9d9;
                    cursor: pointer;
                    width: 150px;
                    position: relative;
                  "
                >
                  <img
                    v-if="gzhTabData[gzh_tab_index].contentData.xcx_media_url"
                    :src="gzhTabData[gzh_tab_index].contentData.xcx_media_url"
                    style="width: 100%; height: 150px; object-fit: contain"
                    alt=""
                  />
                  <div
                    v-else
                    style="
                      height: 150px;
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      color: #999;
                    "
                  >
                    <div style="text-align: center">
                      <a-icon
                        :type="e_img_loading ? 'loading' : 'plus'"
                        style="font-size: 22px"
                      />
                      <div>图片上传</div>
                    </div>
                  </div>

                  <div
                    v-if="gzhTabData[gzh_tab_index].contentData.xcx_media_url"
                    class="cover-handle"
                  >
                    <div
                      @click.stop="cutCover(3)"
                      style="color: #fff; text-align: center; cursor: pointer"
                    >
                      <a-icon style="font-size: 18px" type="scissor" />
                      <div>裁剪封面</div>
                    </div>
                    <div
                      style="color: #fff; text-align: center; cursor: pointer"
                    >
                      <a-icon style="font-size: 18px" type="swap" />
                      <div>更换封面</div>
                    </div>
                  </div>
                </div>
              </a-upload>
            </div>
          </div>
        </template>

        <div class="form-cell-box">
          <div class="class-title">开启状态</div>
          <a-switch
            :checked="gzhTabData[gzh_tab_index].contentData.e_switch"
            checked-children="开启"
            un-checked-children="关闭"
            @change="addStatusChange($event)"
          />
        </div>

        <!-- 加载状态 -->
        <div
          style="
            position: absolute;
            left: 50%;
            top: 45%;
            transform: translate(-50%, -50%);
            z-index: 9;
          "
          v-show="modal_search_loading"
        >
          <a-spin size="large" />
        </div>
      </div>
    </a-modal>

    <cropperImgModal
      ref="getCropperImg"
      @cropper-ok="cropperOk"
    ></cropperImgModal>
  </div>
</template>

<script>
import {
  followReplyMsgPreview,
  gzhKeywordAdd,
  gzhKeywordEdit,
  gzhGroupGet,
  gzhContactEdit,
  gzhContactAdd,
} from "@/request/api";
import cropperImgModal from "./cropperImgModal.vue";
export default {
  name: "keywordReplyModal_",
  props: [
    "config_id",
    "msg_channel_id",
    "msg_channel_name",
    "handle_title",
    "page_type",
    "set_type",
  ],
  components: {
    cropperImgModal,
  },
  data() {
    return {
      // config_id: null, // 点击的表格内的公众号id

      // 编辑/新增 弹窗
      msg_modal_loading: false,
      msg_modal_visible: false,
      modal_width: 600, // 输入框宽度
      e_type: 1, // 消息类型
      e_title: "", // 消息名称
      e_send_time: 1, // 推送时机
      e_switch: false, // 开启状态
      e_openid: "",

      e_text_content: "", // 文本消息--文本消息内容

      e_img_url: "", // 图片消息，的图片链接
      e_img_media_id: "", // 图片消息，的media_id

      e_txtImg_title: "", // 单图文消息 - 标题
      e_txtImg_description: "", // 单图文消息 - 描述
      e_txtImg_url: "", // 单图文消息 -  跳转链接
      e_txtImg_image: "", // 单图文消息 - 图片oss
      e_txtImg_path: "", // 单图文消息 - 图片地址

      e_txtImgData: [
        {
          select_status: true,
          title: "",
          description: "",
          url: "",
          image: "",
        },
      ], // 多图文素材
      content_index: 0,

      headers_token: "", // 图片上传用的token

      e_img_loading: false,
      msg_preview_loading: false,

      pl_gzh_select: false,
      gzhData: [], // 公众号分组的数据
      gzhTabData: [
        {
          gzh_name: null,
          contentData: {
            // 之所要把这些写出来是为了把这些数据变成响应式的，不然编辑的时候视图上不会更新
            e_title: null,
            e_send_time: 1,
            e_type: 1,
            id: null,
            e_txtImg_index: 0,
          },
        },
      ], // tab栏的公众号
      gzh_tab_index: 0, // 当前选中公众号tab的索引

      edit_id: null,

      gzh_list_top: 41,

      modal_search_loading: false,
    };
  },
  mounted() {
    // 图片上传用的token
    this.headers_token = "Bearer " + localStorage.getItem("access_token");
  },
  methods: {
    // 给ant design的select选择器重新设置定位
    getsPopupContainer(triggerNode) {
      // console.log("getsPopupContainer",triggerNode)
      return triggerNode.parentNode || document.body;
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    showModal(data) {
      data[0].contentData = {
        e_title: "", // 消息名称
        e_send_time: 1, // 推送时机
        e_type: 1, // 消息类型
        e_switch: false, // 开启状态

        e_text_content: "", // 文本消息

        e_img_url: "", // 图片消息，的图片链接
        e_img_media_id: "", // 图片消息，的media_id

        e_txtImg_title: "", // 单图文消息 - 标题
        e_txtImg_description: "", // 单图文消息 - 描述
        e_txtImg_url: "", // 单图文消息 -  跳转链接
        e_txtImg_image: "", // 单图文消息 - 图片oss
        e_txtImg_path: "", // 单图文消息 - 图片地址

        // e_txtImgData: [{
        // 	select_status: true,
        // 	title: "",
        // 	description: "",
        // 	url: "",
        // 	image: "",
        // }], // 多图文素材
        e_txtImg_index: 0,

        xcx_title: "", // 小程序标题
        xcx_appid: "", // 小程序appid
        xcx_pagepath: "", // 小程序路径
        xcx_media_url: "", // 小程序消息封面
        xcx_media_id: "", // 小程序消息封面
      };
      console.log("data", data);
      this.gzhTabData = data;
      this.msg_modal_visible = true;

      // 获取公众号分组
      // this.addMsgGzh()
    },
    editModal(item, gdata) {
      // 编辑、预览
      let that = this;
      console.log("gdata", gdata);
      that.edit_id = item.id;
      that.gzhTabData[that.gzh_tab_index].gzh_name = gdata[0].gzh_name;
      // console.log("that.gzhTabData[that.gzh_tab_index]",that.gzhTabData[that.gzh_tab_index]);
      // 这里如果要用深拷贝和浅拷贝的话，就要把gzh_data赋值给that.gzhTabData[that.gzh_tab_index].contentData
      // 不然页面会没有反应
      let gzh_data = that.gzhTabData[that.gzh_tab_index].contentData;
      // let gzh_data = {}
      gzh_data.e_title = item.title || item.keyword;
      gzh_data.e_send_time = item.send_time || 1;
      gzh_data.e_type = item.type;
      gzh_data.id = item.gzh_id;
      gzh_data.e_txtImg_index = 0;

      if (item.status == 1) {
        gzh_data.e_switch = true;
      } else {
        gzh_data.e_switch = false;
      }

      // 对图片体积进行处理，避免图片体积过大，加载过久
      let i_data = JSON.parse(JSON.stringify(item.content));
      let img_resize = "?x-oss-process=image/resize,h_150,m_lfit";

      if (item.type == 1) {
        // 文本消息
        gzh_data.e_text_content = item.content.content;
      } else if (item.type == 2) {
        // 图片消息
        gzh_data.e_img_media_id = i_data.media_id;
        gzh_data.e_img_url =
          i_data.media_id_url +
          (i_data.media_id_url.indexOf("?") > -1 ? "" : img_resize);
      } else if (item.type == 3) {
        // 单图文消息
        gzh_data.e_txtImg_title = i_data.title; // 单图文消息 - 标题
        gzh_data.e_txtImg_description = i_data.description; // 单图文消息 - 描述
        gzh_data.e_txtImg_url = i_data.url; // 单图文消息 -  跳转链接
        gzh_data.e_txtImg_image =
          i_data.image + (i_data.image.indexOf("?") > -1 ? "" : img_resize); // 单图文消息 - 图片地址
      } else if (item.type == 4) {
        // 多图文消息
        i_data.forEach((res) => {
          res.image =
            res.image + (res.image.indexOf("?") > -1 ? "" : img_resize);
        });
        // console.log(gzh_data.e_txtImgData)
        gzh_data.e_txtImgData = i_data;
        // console.log("1111",gzh_data.e_txtImgData)
      } else if (item.type == 5) {
        // 小程序
        gzh_data.xcx_title = i_data.title;
        gzh_data.xcx_appid = i_data.appid;
        gzh_data.xcx_pagepath = i_data.pagepath;
        gzh_data.xcx_media_url =
          i_data.thumb_media_id_url +
          (i_data.thumb_media_id_url.indexOf("?") > -1 ? "" : img_resize); // 单图文消息 - 图片地址
        gzh_data.xcx_media_id = i_data.thumb_media_id;
      }
      // console.log("that.gzhTabData",that.gzhTabData);
      // this.$set(that.gzhTabData, that.gzh_tab_index, gzh_data)
      // that.gzhTabData[that.gzh_tab_index].contentData = gzh_data
      that.msg_modal_visible = true;
    },
    // 新建消息弹窗操作按钮
    msgHandleOk(value) {
      let that = this;
      console.log("that.gzhTabData", that.gzhTabData);
      if (that.gzhTabData.length == 0) {
        that.$message.warning("公众号不能为空");
        return;
      }

      let r_arr = [];
      const for_gzh = new Promise((resolve, reject) => {
        let r_number = 0;
        for (let i = 0; i < that.gzhTabData.length; i++) {
          if (!that.gzhTabData[i].contentData.e_title) {
            that.$message.warning(
              `公众号:${that.gzhTabData[i].gzh_name}---请填写消息名称`
            );
            break;
          } else {
            let r_data = {
              gzh_id: that.gzhTabData[i].id,

              type: that.gzhTabData[i].contentData.e_type,
              status: that.gzhTabData[i].contentData.e_switch ? 1 : 0,

              content: {},
            };
            if (that.page_type == "contact") {
              // 客服消息
              r_data.title = that.gzhTabData[i].contentData.e_title;
              // 这里传的是分钟，后端那边会直接转换成秒
              r_data.send_time =
                that.gzhTabData[i].contentData.e_send_time || 1;
            } else {
              r_data.keyword = that.gzhTabData[i].contentData.e_title;
            }

            let g_data = that.gzhTabData[i].contentData;
            if (g_data.e_type == 1) {
              // 文本消息
              if (!g_data.e_text_content) {
                that.$message.warning(
                  `公众号:${that.gzhTabData[i].gzh_name}---请填写文本消息内容`
                );
                return;
              }

              r_data.content.content = encodeURIComponent(
                g_data.e_text_content
              );
              // console.log(that.handle_title)
              r_number = r_number + 1;
            } else if (g_data.e_type == 2) {
              // 图片消息
              if (!g_data.e_img_media_id || !g_data.e_img_url) {
                that.$message.warning(
                  `公众号:${that.gzhTabData[i].gzh_name}---缺少图片信息`
                );
                return;
              }
              r_data.content.media_id = g_data.e_img_media_id;
              r_data.content.media_id_url = g_data.e_img_url;

              r_number = r_number + 1;
            } else if (g_data.e_type == 3) {
              // 单图文消息
              if (!g_data.e_txtImg_title) {
                that.$message.warning(
                  `公众号:${that.gzhTabData[i].gzh_name}---请填写消息标题`
                );
                return;
              } else if (!g_data.e_txtImg_description) {
                that.$message.warning(
                  `公众号:${that.gzhTabData[i].gzh_name}---请填写消息描述`
                );
                return;
              } else if (!g_data.e_txtImg_url) {
                that.$message.warning(
                  `公众号:${that.gzhTabData[i].gzh_name}---请上传消息链接`
                );
                return;
              } else if (!g_data.e_txtImg_image) {
                that.$message.warning(
                  `公众号:${that.gzhTabData[i].gzh_name}---请填写消息图片`
                );
                return;
              }
              r_data.content.title = g_data.e_txtImg_title;
              r_data.content.description = g_data.e_txtImg_description;
              r_data.content.url = g_data.e_txtImg_url;
              r_data.content.image = g_data.e_txtImg_image;

              r_number = r_number + 1;
            } else if (g_data.e_type == 4) {
              // 多图文消息
              r_data.content = g_data.e_txtImgData;
              for (let i = 0; i < g_data.e_txtImgData.length; i++) {
                if (!g_data.e_txtImgData[i].title) {
                  that.$message.warning(
                    `公众号:${that.gzhTabData[i].gzh_name}---请输入消息标题`
                  );
                  return;
                } else if (!g_data.e_txtImgData[i].description) {
                  that.$message.warning(
                    `公众号:${that.gzhTabData[i].gzh_name}---请输入消息描述`
                  );
                  return;
                } else if (!g_data.e_txtImgData[i].image) {
                  that.$message.warning(
                    `公众号:${that.gzhTabData[i].gzh_name}---请选择消息图片`
                  );
                  return;
                } else if (!g_data.e_txtImgData[i].url) {
                  that.$message.warning(
                    `公众号:${that.gzhTabData[i].gzh_name}---请输入消息链接URL`
                  );
                  return;
                }
              }

              r_number = r_number + 1;
            } else if (g_data.e_type == 5) {
              // 小程序
              if (!g_data.xcx_title) {
                that.$message.warning(
                  `公众号:${that.gzhTabData[i].gzh_name}---请填写小程序消息标题`
                );
                return;
              } else if (!g_data.xcx_appid) {
                that.$message.warning(
                  `公众号:${that.gzhTabData[i].gzh_name}---请填写小程序APPID`
                );
                return;
              } else if (!g_data.xcx_pagepath) {
                that.$message.warning(
                  `公众号:${that.gzhTabData[i].gzh_name}---请填写小程序路径`
                );
                return;
              } else if (!g_data.xcx_media_url) {
                that.$message.warning(
                  `公众号:${that.gzhTabData[i].gzh_name}---请填写消息封面`
                );
                return;
              }
              r_data.content.title = g_data.xcx_title;
              r_data.content.appid = g_data.xcx_appid;
              r_data.content.pagepath = g_data.xcx_pagepath;
              r_data.content.thumb_media_id = g_data.xcx_media_id;
              r_data.content.thumb_media_id_url = g_data.xcx_media_url;

              r_number = r_number + 1;
            }
            // console.log("000000",r_data);
            r_arr.push(r_data);
            if (r_number == that.gzhTabData.length) {
              // 保证循环完毕
              resolve("校验成功");
            }
          }
        }
      });

      for_gzh.then((res) => {
        let r_data = {
          message: r_arr,
          content_type: that.set_type === "h5" ? 1 : 2,
        };
        // console.log("r_data",r_data)

        that.msg_modal_loading = true;
        if (that.handle_title == "新建") {
          if (that.page_type == "contact") {
            // 客服消息
            gzhContactAdd(r_data).then((res) => {
              console.log("新增文本");
              that.msg_modal_loading = false;
              if (
                res.data.code == 0 ||
                res.data.code == 200 ||
                res.data.code == 8011
              ) {
                that.$message.success("新增成功");
                that.msg_modal_visible = false;
                // that.configSearch()
                that.$emit("handle-success", "");
              } else {
                if (res.data.code == 401) {
                  // 未登录
                  localStorage.removeItem("access_token");
                  that.$router.replace({
                    name: "login",
                    params: { type: "not_log" },
                  });
                } else {
                  that.$message.error(`错误：${res.data.msg}`);
                }
              }
            });
          } else {
            gzhKeywordAdd(r_data).then((res) => {
              console.log("新增文本");
              that.msg_modal_loading = false;
              if (
                res.data.code == 0 ||
                res.data.code == 200 ||
                res.data.code == 8011
              ) {
                that.$message.success("新增成功");
                that.msg_modal_visible = false;
                // that.configSearch()
                that.$emit("handle-success", "");
              } else {
                if (res.data.code == 401) {
                  // 未登录
                  localStorage.removeItem("access_token");
                  that.$router.replace({
                    name: "login",
                    params: { type: "not_log" },
                  });
                } else {
                  that.$message.error(`错误：${res.data.msg}`);
                }
              }
            });
          }
        } else if (that.handle_title == "编辑") {
          r_arr[0].id = that.edit_id;
          if (that.page_type == "contact") {
            // 客服消息
            gzhContactEdit({
              ...r_arr[0],
              content_type: that.set_type === "h5" ? 1 : 2,
            }).then((res) => {
              console.log("编辑文本");
              that.msg_modal_loading = false;
              if (
                res.data.code == 0 ||
                res.data.code == 200 ||
                res.data.code == 8011
              ) {
                that.$message.success("编辑成功");
                that.msg_modal_visible = false;
                // that.configSearch()
                that.$emit("handle-success", "");
              } else {
                if (res.data.code == 401) {
                  // 未登录
                  localStorage.removeItem("access_token");
                  that.$router.replace({
                    name: "login",
                    params: { type: "not_log" },
                  });
                } else {
                  that.$message.error(`错误：${res.data.msg}`);
                }
              }
            });
          } else {
            gzhKeywordEdit({
              ...r_arr[0],
              content_type: that.set_type === "h5" ? 1 : 2,
            }).then((res) => {
              console.log("编辑文本");
              that.msg_modal_loading = false;
              if (
                res.data.code == 0 ||
                res.data.code == 200 ||
                res.data.code == 8011
              ) {
                that.$message.success("编辑成功");
                that.msg_modal_visible = false;
                // that.configSearch()
                that.$emit("handle-success", "");
              } else {
                if (res.data.code == 401) {
                  // 未登录
                  localStorage.removeItem("access_token");
                  that.$router.replace({
                    name: "login",
                    params: { type: "not_log" },
                  });
                } else {
                  that.$message.error(`错误：${res.data.msg}`);
                }
              }
            });
          }
        }
      });
    },
    msgHandleCancel() {
      this.msg_modal_visible = false;
      this.msg_modal_loading = false;
      this.msg_preview_loading = false;

      this.pl_gzh_select = false;

      this.e_openid = "";
    },
    messTypeA(e) {
      this.gzhTabData[this.gzh_tab_index].contentData.e_type = e.target.value;
    },
    addStatusChange(e) {
      // 开启状态
      this.gzhTabData[this.gzh_tab_index].contentData.e_switch = e;
      // this.$set(this.gzhTabData, this.gzh_tab_index, {
      //   contentData: {
      //     ...this.gzhTabData[this.gzh_tab_index].contentData,
      //     e_switch: e,
      //   },
      // });
    },

    // 图片上传 限制用户上传的图片格式和大小。
    beforeUpload(file) {
      console.log("beforeUpload", file);
      this.e_img_loading = true;
      this.gzhTabData[this.gzh_tab_index].contentData.e_img_url = "";
      const isJpgOrPng =
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg" ||
        file.type === "image/gif";
      if (!isJpgOrPng) {
        this.e_img_loading = false;
        this.$message.error("图片格式只能为：PNG、JPEG、JPG/GIF");
      }
      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!isLt2M) {
        this.e_img_loading = false;
        this.$message.error("图片大小不能超过10MB!");
      }
      return isJpgOrPng && isLt2M;
    },
    uploadChange(info) {
      console.log("图片请求", info);
      let that = this;

      if (info.file.status === "uploading") {
        return;
      }
      if (info.file.status === "done") {
        that.e_img_loading = false;
        console.log("图片请求done", info);
        if (info.file.response) {
          // 图片上传成功，有内容返回
          if (info.file.response.code == 401) {
            that.$message.error(`错误：${info.file.response.msg}`);
            return;
          }
          let c_data = that.gzhTabData[that.gzh_tab_index].contentData;
          if (c_data.e_type == 2) {
            // 图片消息
            // that.gzhTabData[that.gzh_tab_index].contentData.e_img_url =
            //   info.file.response.data.data.url;
            // that.gzhTabData[that.gzh_tab_index].contentData.e_img_media_id =
            //   info.file.response.data.data.media_id;

            that.$set(that.gzhTabData[that.gzh_tab_index], "contentData", {
              ...that.gzhTabData[that.gzh_tab_index].contentData,
              e_img_url: info.file.response.data.data.url,
              e_img_media_id: info.file.response.data.data.media_id,
            });
          } else if (c_data.e_type == 5) {
            // 小程序卡片消息
            // that.gzhTabData[that.gzh_tab_index].contentData.xcx_media_url =
            //   info.file.response.data.data.url;
            // that.gzhTabData[that.gzh_tab_index].contentData.xcx_media_id =
            //   info.file.response.data.data.media_id;
            that.$set(that.gzhTabData[that.gzh_tab_index], "contentData", {
              ...that.gzhTabData[that.gzh_tab_index].contentData,
              xcx_media_url: info.file.response.data.data.url,
              xcx_media_id: info.file.response.data.data.media_id,
            });
          }
        } else {
          this.$message.error(`错误：图片上传失败`);
        }
      }

      if (info.file.status === "error") {
        // 上传失败

        this.loading = false;
        this.$message.error(`错误：图片上传失败`);
      }
    },

    // 图文消息上传
    txtimgBeforeUpload(file) {
      console.log("beforeUpload", file);
      this.e_img_loading = true;
      this.gzhTabData[this.gzh_tab_index].contentData.e_txtImg_image = "";
      const isJpgOrPng =
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg" ||
        file.type === "image/gif";
      if (!isJpgOrPng) {
        this.e_img_loading = false;
        this.$message.error("图片格式只能为：PNG、JPEG、JPG/GIF");
      }
      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!isLt2M) {
        this.e_img_loading = false;
        this.$message.error("图片大小不能超过10MB!");
      }
      return isJpgOrPng && isLt2M;
    },
    txtimgUploadChange(info) {
      console.log("图片请求", info);
      let that = this;

      if (info.file.status === "uploading") {
        return;
      }
      if (info.file.status === "done") {
        that.e_img_loading = false;
        // console.log("图片请求done",info);
        if (info.file.response) {
          // 图片上传成功，有内容返回
          if (info.file.response.code == 401) {
            that.$message.error(`错误：${info.file.response.msg}`);
            return;
          }
          // path: "gzh-local-message/OMs8b00Tkja3PVWNSyd5fhH5SfHVdnTCkzFcTtUD.jpg"
          // url: "https://oss.gzlize.com/gzh-local-message/OMs8b00Tkja3PVWNSyd5fhH5SfHVdnTCkz
          let gzh_data = that.gzhTabData[that.gzh_tab_index].contentData;
          if (gzh_data.e_type == 3) {
            // 单图文
            // gzh_data.e_txtImg_image = info.file.response.data.url;
            // gzh_data.e_txtImg_path = info.file.response.data.path;
            // 编辑操作的时候，替换图片，视图不更新，所以这里处理一下
            // that.$delete(that.gzhTabData[that.gzh_tab_index], "contentData");
            that.$set(that.gzhTabData[that.gzh_tab_index], "contentData", {
              ...that.gzhTabData[that.gzh_tab_index].contentData,
              e_txtImg_image: info.file.response.data.url,
              e_txtImg_path: info.file.response.data.path,
            });
          } else if (gzh_data.e_type == 4) {
            // 多图文
            gzh_data.e_txtImgData[gzh_data.e_txtImg_index].image =
              info.file.response.data.url;
            // 编辑操作的时候，替换图片，视图不更新，所以这里处理一下
            // that.$delete(that.gzhTabData[that.gzh_tab_index], "contentData");
            that.$set(
              that.gzhTabData[that.gzh_tab_index],
              "contentData",
              gzh_data
            );
          } else if (gzh_data.e_type == 5) {
            // 小程序
            gzh_data.xcx_media_url = info.file.response.data.url;
            gzh_data.xcx_media_id = info.file.response.data.path;
            // 编辑操作的时候，替换图片，视图不更新，所以这里处理一下
            // that.$delete(that.gzhTabData[that.gzh_tab_index], "contentData");
            that.$set(that.gzhTabData[that.gzh_tab_index], "contentData", {
              ...that.gzhTabData[that.gzh_tab_index].contentData,
              xcx_media_url: info.file.response.data.url,
              xcx_media_id: info.file.response.data.path,
            });
          }
        } else {
          this.$message.error(`错误：图片上传失败`);
        }
      }

      if (info.file.status === "error") {
        // 上传失败

        this.loading = false;
        this.$message.error(`错误：图片上传失败`);
      }
    },

    // 新建素材
    addContent() {
      this.gzhTabData[this.gzh_tab_index].contentData.e_txtImgData.push({
        select_status: false,
        title: "",
        description: "",
        url: "",
        image: "",
      });
    },
    // 删除图文-确认按钮
    confirmDelImg(index) {
      let gzh_data = this.gzhTabData[this.gzh_tab_index].contentData;
      console.log("index", index);
      console.log("gzh_data", gzh_data);
      if (gzh_data.e_txtImgData.length > 1) {
        if (gzh_data.e_txtImgData[index].select_status) {
          // 为选中状态就不能直接删，因为页面正在显示当前选中的数据
          gzh_data.e_txtImgData[index].select_status = false;
          if (index == 0) {
            // 表示删除第一个
            gzh_data.e_txtImg_index = 0;
            gzh_data.e_txtImgData[index + 1].select_status = true;
          } else if (index == gzh_data.e_txtImgData.length - 1) {
            // 删最后一个
            gzh_data.e_txtImg_index = index - 1;
            gzh_data.e_txtImgData[index - 1].select_status = true;
          } else {
            gzh_data.e_txtImg_index = index - 1;
            gzh_data.e_txtImgData[index - 1].select_status = true;
          }
        }

        // 选中第三个，删除第二个，会报错，因为索引不到，所以要重新调整索引
        if (gzh_data.e_txtImg_index >= index) {
          gzh_data.e_txtImg_index = 0;
          gzh_data.e_txtImgData.forEach((res) => {
            res.select_status = false;
          });
          gzh_data.e_txtImgData[gzh_data.e_txtImg_index].select_status = true;
        }

        gzh_data.e_txtImgData.splice(index, 1);
      } else {
        this.$message.warning("不能全部删除");
      }
    },
    // 切换显示的内容
    changeMaterial(item, index) {
      console.log(item);
      this.gzhTabData[this.gzh_tab_index].contentData.e_txtImgData.forEach(
        (res) => {
          console.log(index);
          res.select_status = false;
        }
      );
      item.select_status = true;
      this.gzhTabData[this.gzh_tab_index].contentData.e_txtImg_index = index;
    },

    // 预览
    sendPreview() {},

    // 裁切图片
    cutCover() {
      let that = this;

      let gzh_data = this.gzhTabData[this.gzh_tab_index].contentData;
      // console.log('裁切图片',gzh_data.e_txtImgData[gzh_data.e_txtImg_index].image.split('?'))

      let o_data;
      let f_n = [];
      if (gzh_data.e_type == 4) {
        // 多图文
        // console.log('多图文',gzh_data.e_txtImgData[gzh_data.e_txtImg_index].image.split('?'))
        if (gzh_data.e_txtImg_index == 0) {
          f_n = [23.47, 10];
        } else {
          f_n = [10, 10];
        }
        o_data =
          gzh_data.e_txtImgData[gzh_data.e_txtImg_index].image.split("?");
      } else if (gzh_data.e_type == 5) {
        // 小程序卡片
        f_n = [5, 4];
        o_data = gzh_data.xcx_media_url.split("?");
      } else {
        // 单图文
        f_n = [10, 10];
        o_data = gzh_data.e_txtImg_image.split("?");
      }

      this.$refs.getCropperImg.cutImgHandle(o_data[0], f_n);
    },

    // 裁切弹窗确认
    cropperOk(img) {
      let that = this;
      let gzh_data = this.gzhTabData[this.gzh_tab_index].contentData;
      if (gzh_data.e_type == 4) {
        // 多图文
        gzh_data.e_txtImgData[gzh_data.e_txtImg_index].image = img;
      } else if (gzh_data.e_type == 5) {
        // 小程序卡片
        gzh_data.xcx_media_url = img;
      } else {
        // 单图文
        gzh_data.e_txtImg_image = img;
      }

      that.$delete(that.gzhTabData[that.gzh_tab_index], "contentData");
      that.$set(that.gzhTabData[that.gzh_tab_index], "contentData", gzh_data);

      this.$refs.getCropperImg.cutHandleCancel();
    },

    // 公众号分组
    // 添加公众号
    addMsgGzh() {
      let that = this;

      console.log("this.msg_channel_id", this.msg_channel_id);
      if (!this.msg_channel_id) {
        this.$message.warning("当前公众号没有渠道");
        return;
      }

      if (this.pl_gzh_select) {
        this.pl_gzh_select = false;
      } else {
        that.modal_search_loading = true;
        // if(that.gzhData.length == 0){
        gzhGroupGet({
          channel_id: this.msg_channel_id,
        }).then((res) => {
          that.modal_search_loading = false;
          console.log("res", res);
          let data = res.data.data.list;
          let arr = [];
          for (let key in data) {
            let obj = {
              label: key,
              checked_all: false,
              indeterminate_all: false,
            };
            data[key].forEach((res) => {
              res.checked_z = false;
            });
            obj.value = data[key];
            arr.push(obj);
          }
          // console.log("arr",arr);

          // 把当前tab栏里的公众号进行高亮
          arr.forEach((res_f) => {
            res_f.value.forEach((res) => {
              that.gzhTabData.forEach((res_z) => {
                if (res.id == res_z.id) {
                  res.checked_z = true;
                }
              });
            });
          });

          // console.log("arr",arr);
          that.gzhData = arr;
          that.pl_gzh_select = !that.pl_gzh_select;

          // 用于判断是否全选
          // let ttt = true
          // that.gzhData[index].value.forEach(res=>{
          // 	if(!res.checked_z){
          // 		ttt = false
          // 	}
          // })
          // if(ttt){
          // 	that.gzhData[index].checked_all = true // 全选
          // }
          // else {
          // 	that.gzhData[index].checked_all = false // 取消全选
          // }

          // 计算top值
          that.computedTop();
        });
        // }
        // else {
        // 	this.pl_gzh_select = !this.pl_gzh_select
        // }
      }
    },
    // 全选/取消全选
    onCheckAllChange(e, item, index) {
      let that = this;
      if (that.gzhData[index].checked_all) {
        that.gzhData[index].value.forEach((res) => {
          if (res.id != that.gzhTabData[0].id) {
            // 第一个不能删
            res.checked_z = false;
          }
        });
        that.gzhData[index].checked_all = false;
      } else {
        that.gzhData[index].value.forEach((res) => {
          res.checked_z = true;
        });
        that.gzhData[index].checked_all = true;
      }

      // 把选择的tab公众号放入或者删除
      console.log("that.gzhData[index]", that.gzhData[index]);
      if (that.gzhData[index].checked_all) {
        // 所有内容被选中
        that.gzhData[index].value.forEach((res) => {
          // 判断是否有重复，有重复的话就不用再添加了
          let ddd = true;
          for (let i = 0; i < that.gzhTabData.length; i++) {
            if (that.gzhTabData[i].id == res.id) {
              ddd = false;
              break;
            }
          }
          if (ddd) {
            let gzh_data = JSON.parse(
              JSON.stringify(that.gzhTabData[0].contentData)
            );

            let obj = {
              gzh_name: res.gzh_name,
              id: res.id,
              select_status: false,
              contentData: {
                e_title: gzh_data.e_title, // 消息名称
                e_send_time: gzh_data.e_send_time, // 推送时机
                e_type: gzh_data.e_type, // 消息类型
                e_switch: gzh_data.e_switch, // 开启状态

                e_text_content: gzh_data.e_text_content, // 文本消息

                e_img_url: gzh_data.e_img_url, // 图片消息，的图片链接
                e_img_media_id: gzh_data.e_img_media_id, // 图片消息，的media_id

                e_txtImg_title: gzh_data.e_txtImg_title, // 单图文消息 - 标题
                e_txtImg_description: gzh_data.e_txtImg_description, // 单图文消息 - 描述
                e_txtImg_url: gzh_data.e_txtImg_url, // 单图文消息 -  跳转链接
                e_txtImg_image: gzh_data.e_txtImg_image, // 单图文消息 - 图片oss
                e_txtImg_path: gzh_data.e_txtImg_path, // 单图文消息 - 图片地址

                e_txtImgData: gzh_data.e_txtImgData, // 多图文素材
                e_txtImg_index: gzh_data.e_txtImg_index,

                xcx_title: gzh_data.title, // 小程序
                xcx_appid: gzh_data.appid, // 小程序
                xcx_pagepath: gzh_data.pagepath, // 小程序
                xcx_media_url: gzh_data.thumb_media_id_url, // 小程序
                xcx_media_id: gzh_data.thumb_media_id, // 小程序
              },
            };
            that.gzhTabData.push(obj);

            // 计算top值
            that.computedTop();
          }
        });
      } else {
        // 所有内容被取消选中
        // 都已经全部删除了，这里就把选中状态改为第一个，不然假设有选中第10个内容，然后全部删除的话gzh_tab_index为10，会获取不到内容然后报错
        that.gzh_tab_index = 0;
        that.gzhTabData[0].select_status = true;

        that.gzhData[index].value.forEach((res_f) => {
          let iii = null;
          that.gzhTabData.forEach((res, index_g) => {
            if (res.id == res_f.id) {
              iii = index_g;
            }
          });
          if (iii != null) {
            if (iii != 0) {
              // 第一个不能删
              that.gzhTabData.splice(iii, 1);
              // 计算top值
              that.computedTop();
            }
          }
        });
      }
    },
    // 单选
    onCheckChange(e, index, index_z) {
      let that = this;
      // console.log("---",that.gzhData[index].value[index_z])

      // 新增消息是根据第一个选中的公众号来的，不能删
      if (that.gzhTabData[0].id == that.gzhData[index].value[index_z].id) {
        that.$message.warning("该公众号不能删除");
        return;
      }

      that.gzhData[index].value[index_z].checked_z =
        !that.gzhData[index].value[index_z].checked_z;

      let ttt = true; // 用于判断是否全选
      that.gzhData[index].value.forEach((res) => {
        if (!res.checked_z) {
          ttt = false;
        }
      });
      if (ttt) {
        that.gzhData[index].checked_all = true; // 全选
      } else {
        that.gzhData[index].checked_all = false; // 取消全选
      }

      // console.log("checked_z",that.gzhData[index].value[index_z].checked_z);
      if (that.gzhData[index].value[index_z].checked_z) {
        // 被选中了
        // 判断是否有重复，有重复的话就不用再添加了
        let ddd = true;
        for (let i = 0; i < that.gzhTabData.length; i++) {
          if (that.gzhTabData[i].id == that.gzhData[index].value[index_z].id) {
            ddd = false;
            break;
          }
        }
        if (ddd) {
          let gzh_data = JSON.parse(
            JSON.stringify(that.gzhTabData[0].contentData)
          );
          let obj = {
            gzh_name: that.gzhData[index].value[index_z].gzh_name,
            id: that.gzhData[index].value[index_z].id,
            select_status: false,
            contentData: {
              e_title: gzh_data.e_title, // 消息名称
              e_send_time: gzh_data.e_send_time, // 推送时机
              e_type: gzh_data.e_type, // 消息类型
              e_switch: gzh_data.e_switch, // 开启状态

              e_text_content: gzh_data.e_text_content, // 文本消息

              e_img_url: gzh_data.e_img_url, // 图片消息，的图片链接
              e_img_media_id: gzh_data.e_img_media_id, // 图片消息，的media_id

              e_txtImg_title: gzh_data.e_txtImg_title, // 单图文消息 - 标题
              e_txtImg_description: gzh_data.e_txtImg_description, // 单图文消息 - 描述
              e_txtImg_url: gzh_data.e_txtImg_url, // 单图文消息 -  跳转链接
              e_txtImg_image: gzh_data.e_txtImg_image, // 单图文消息 - 图片oss
              e_txtImg_path: gzh_data.e_txtImg_path, // 单图文消息 - 图片地址

              e_txtImgData: gzh_data.e_txtImgData, // 多图文素材
              e_txtImg_index: gzh_data.e_txtImg_index,

              xcx_title: gzh_data.title, // 小程序
              xcx_appid: gzh_data.appid, // 小程序
              xcx_pagepath: gzh_data.pagepath, // 小程序
              xcx_media_url: gzh_data.thumb_media_id_url, // 小程序
              xcx_media_id: gzh_data.thumb_media_id, // 小程序
            },
          };
          that.gzhTabData.push(obj);
        }

        // 计算top值
        that.computedTop();
      } else {
        // 被取消选中了
        console.log("被取消选中", that.gzhTabData);
        let iii = null;
        that.gzhTabData.forEach((res, index_g) => {
          if (res.id == that.gzhData[index].value[index_z].id) {
            iii = index_g;
            console.log("index_g", index_g);
          }
        });
        console.log("iii", iii);
        console.log("that.gzh_tab_index", that.gzh_tab_index);
        if (iii != null) {
          // 如果这里不这么写的话，就会报错。比如选中了第10个，然后删到只剩九个的时候，会去取索引10的内容，但是已经没有10个了就会报错
          if (that.gzhTabData[iii].select_status) {
            that.gzh_tab_index = 0;
            that.gzhTabData[that.gzh_tab_index].select_status = true;
          } else if (that.gzh_tab_index >= that.gzhTabData.length) {
            that.gzh_tab_index = 0;
            that.gzhTabData[that.gzh_tab_index].select_status = true;
          }
          that.gzhTabData.splice(iii, 1);

          // 重新计算gzh_tab_index索引值。假如选中的是第10个，然后删除了第一个，此时gzh_tab_index应该就变为9才对
          let sss = 0;
          that.gzhTabData.forEach((res, index) => {
            if (res.select_status) {
              sss = index;
            }
          });
          console.log("sss", sss);
          that.gzh_tab_index = sss;
        }
        // console.log("iii",iii);
        // console.log("that.gzhTabData",that.gzhTabData);
        // 计算top值
        that.computedTop();
      }
    },
    computedTop() {
      // console.log("搞搞搞",this.$refs.gzh_list_ref.offsetHeight);
      this.$nextTick(() => {
        this.gzh_list_top = this.$refs.gzh_list_ref.offsetHeight + 2;
      });
    },
    // 把选中的公众号分组放入到公众号tab栏里
    selectGzhTab() {},
    // 切换公众号tab
    changeGzhTab(item, index) {
      // console.log("this.gzhTabData",this.gzhTabData);
      this.gzhTabData.forEach((res) => {
        res.select_status = false;
      });
      item.select_status = true;

      this.gzh_tab_index = index;

      this.pl_gzh_select = false;
    },
    bigBox() {
      this.pl_gzh_select = false;
    },
  },
};
</script>

<style scoped>
/* tab项样式 */
.title-tab-box {
  color: #313a46;
  padding: 3px 10px;
  border: 1px solid #ccc;
  cursor: pointer;
  flex-shrink: 0;
}

.title-tab-box-selected {
  color: #62a8ea;
  border: 1px solid #62a8ea;
}

.form-cell-box {
  margin-bottom: 20px;
}

.msg-cell-title {
  margin-bottom: 10px;
}

.left-box {
  /* padding: 15px; */
  /* border: 1px solid #ccc; */
  position: sticky;
  top: 70px;
  width: 300px;
  background: #fff;
  padding: 23px;
}
.left-box-border {
  border: 2px solid #409eff;
}
.left-top-title {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  color: #fff;
  padding: 5px 12px;
}
.left-cell-top {
  position: relative;
  cursor: pointer;
}
.left-cell-box {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  padding: 12px;
}
.left-cell-box-boder {
  border-bottom: 1px solid #e8e8e8;
}
.left-cell-img {
  width: 50px;
  height: 50px;
}
.left-cell-operation {
  display: none;
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 3;
  /* display: flex; */
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 5px 7px;
  background-color: rgba(0, 0, 0, 0.7);
}
.left-cell-top:hover .left-cell-operation {
  display: flex;
}
.left-cell-box:hover .left-cell-operation {
  display: flex;
}
.left-cell-operation-icon {
  color: #fff;
  font-size: 16px;
}
.left-cell-add {
  text-align: center;
  font-size: 16px;
  padding: 15px 0 5px;
  cursor: pointer;
}

/* 图片裁切 */
.cover-handle {
  display: none;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 9;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  /* display: flex; */
  align-items: center;
  justify-content: space-around;
}
.cover-box:hover .cover-handle {
  display: flex;
}

.type-3:hover .cover-handle {
  display: flex;
}

/* 设置滚动条开始 */
/* 滚动条整体 */
.scroll-small-box::-webkit-scrollbar {
  /* height决定横向scrollbar的高度，width决定纵向滚动条的宽度 */
  height: 7px;
  /* width: 7px; */
  /* 默认：滚动条透明底色 */
  background-color: transparent;
}
/* 滚动条滑块 */
.scroll-small-box::-webkit-scrollbar-thumb {
  /* 圆角 */
  border-radius: 10px;
  /* 滑块自身颜色 透明 */
  background-color: transparent;
}
/* 当鼠标hover时 */
.scroll-big-box:hover .scroll-small-box::-webkit-scrollbar {
  /* 底色 */
  /* background-color:#f3f3f3 !important; */
}
.scroll-big-box:hover .scroll-small-box::-webkit-scrollbar-thumb {
  /* 滑块颜色 */
  background-color: #999 !important;
}
.scroll-small-box::-webkit-scrollbar {
  /* display:none; */
  background-color: transparent;
}
/* 设置滚动条结束 */

.class-title {
  user-select: none;
}
</style>
